export default __webpack_public_path__ + "static/media/6_1_logo.823c29c5.png";